import React from 'react';
import PropTypes from 'prop-types';
import ThemeContext, { defaultTheme } from '../ThemeContext';

const ThemeProvider = ({ theme, children }) => (
	<ThemeContext.Provider value={{ ...defaultTheme, ...theme }}>
		{children}
	</ThemeContext.Provider>
);

ThemeProvider.propTypes = {
	/**
	 * JSON object containing mapping of theme with color scheme.
	 */
	theme: PropTypes.object,
	/**
	 * Children where ThemeProvider will inject custom theme
	 */
	children: PropTypes.node,
};

export default ThemeProvider;
